import React from 'react';
import PropTypes from 'prop-types';
import { trackClickEvent } from '@utils/analytics';
import { ReactComponent as FacebookIcon } from '../../svgs/fb.svg';
import { ReactComponent as InstagramIcon } from '../../svgs/insta.svg';
import { ReactComponent as XIcon } from '../../svgs/x.svg';
import { ReactComponent as TiktokIcon } from '../../svgs/tiktok.svg';
import { ReactComponent as YoutubeIcon } from '../../svgs/youtube.svg';
import s from './SocialShareLinks.module.scss';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const SocialShareLinks = ({ className }) => {
  const socialLinks = [
    {
      title: 'Youtube',
      href: 'https://www.youtube.com/channel/UChPRO1CB_Hvd0TvKRU62iSQ',
      icon: <YoutubeIcon title="YouTube" aria-label="YouTube" />,
    },
    {
      title: 'Tiktok',
      href: 'https://www.tiktok.com/@harrypotter',
      icon: <TiktokIcon title="Twitter" aria-label="Tiktok" />,
    },
    {
      title: 'Facebook',
      href: 'https://www.facebook.com/wizardingworld',
      icon: <FacebookIcon title="Facebook" aria-label="Facebook" />,
    },
    {
      title: 'Instagram',
      href: 'https://www.instagram.com/harrypotter',
      icon: <InstagramIcon title="Instagram" aria-label="Instagram" />,
    },
    {
      title: 'X',
      href: 'https://twitter.com/wizardingworld',
      icon: <XIcon title="Twitter" aria-label="X" />,
    },
  ];

  const onSocialIconClick = (socialLink, index) => {
    trackClickEvent({
      destination_url: socialLink.href,
      label: socialLink.title,
      location: 'Footer',
      vertical_index: -1,
      horizontal_index: index,
    });
  };

  return (
    <ul className={className}>
      {socialLinks.map((socialLink, index) => {
        return (
          <li className={s.socialShareItem} key={socialLink.title}>
            <a
              href={socialLink.href}
              onClick={() => {
                onSocialIconClick(socialLink, index);
              }}
            >
              <div className={s.socialShareItem}>{socialLink.icon}</div>
            </a>
          </li>
        );
      })}
    </ul>
  );
};

SocialShareLinks.propTypes = propTypes;
SocialShareLinks.defaultProps = defaultProps;
export default SocialShareLinks;
